import {getPrefixedUrl} from "../../../utils/utils";
import BaseLayer from "./BaseLayer";
import {drawCircle, drawLine, mapMotorToCanvas} from "../utils/map_utils";
import {parseInt} from "lodash/string";
import {Grid, Stack} from "@mui/material";
import React, {Suspense} from "react";
import {zProfileFolderPath} from "../../../utils/const";

const Plot = React.lazy(() => import("react-plotly.js"));

class DropDistance extends BaseLayer {

    id = "dropDistance";
    label = "Drop Distance";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    handlePlotTS = (takeStep) => {
        this.plotData =
            {
                x: takeStep['X'],
                y: takeStep['Y'],
                type: "scatter",
                mode: "markers",
                marker: {color: "red"},
                name: takeStep['Name']
            }
    };

    draw = () => new Promise((resolve, reject) => {
        let {dropDistance, dropDistImages, deviceSettings, dropDistPlots, tileFlag, textColor} = this.props;
        let {y_fields, tile_height, uperpixel, loc_on_machine, bucket_name, tile_viewer_path} = this.props.slide;
        Object.values(dropDistImages).forEach(val => {
            let index = parseInt(val["index"]);
            const xPosition = parseInt(dropDistance[index]["xPosition"]);
            const yPosition = parseInt(dropDistance[index]["yPosition"]);
            let {x, y} = mapMotorToCanvas(xPosition, yPosition, this.props.slide,
                {device_settings: deviceSettings});
            if (tileFlag['reverseYTileOrder']['flagY'])
                y = y_fields * tile_height * uperpixel - y;
            drawLine(x, y, 1, this.layer.getSource(), val["index"], 10, "#E9D6C5", "",
                textColor);
            Object.values(dropDistPlots).forEach(ddPlot => {
                this.plotData = {};
                if (parseInt(ddPlot['index']) === parseInt(val['index'])) {
                    Object.values(ddPlot['dropDistance']).forEach(value => {
                        this.handlePlotTS(value);
                    });
                    let popup = (
                        <Grid>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Plot data={[this.plotData]}/>
                            </Suspense>
                        </Grid>
                    );
                    drawLine(x + 0.1 * tile_height * uperpixel, y, 1, this.layer.getSource(),
                        "[PLOT]", 10, "#f4c2c2", popup, textColor, 10);
                }
            });
            let link1 = getPrefixedUrl(`debug/zprofile/${val["pre_focus_img"]}`, this.props.slide, true);
            let link2 = getPrefixedUrl(`debug/zprofile/${val["thresh_img"]}`, this.props.slide, true);
            let folderLink = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                zProfileFolderPath + val["folder"] + "/";
            let popupText = (
                <Stack>
                    <Grid>
                        <a href={folderLink}>{"Folder Location "}</a><br/>
                        <a href={link1} target={"_blank"}>{"[Pre Focus Img] "}</a>
                        <a href={link2} target={"_blank"}>{" [Thresholded Img]"}</a>
                    </Grid>
                </Stack>
            );
            drawCircle(x, y, 55, this.layer.getSource(), "", 8, "#0022ff", popupText,
                textColor);
        });
        resolve();
    });
}

export default DropDistance;
